(function() {
    const addAdditionalInfo = async () => {
        const actionsButtonsContainer = document.querySelector('.cpb-product-actions-container')
        if (!actionsButtonsContainer) return

        const api = await window.CPB.createFrontApi('');
        const { Product } = api.State

        Product.metafields.forEach(meta => {
            if (meta.key === "additional-top") {
                const topContainer = document.createElement('div')
                topContainer.innerHTML = meta.value

                actionsButtonsContainer.before(topContainer)
            }

            if (meta.key === "additional-bottom") {
                const bottomContainer = document.createElement('div')
                bottomContainer.innerHTML = meta.value

                actionsButtonsContainer.after(bottomContainer)
            }
        })
    }

    const fixStickyPreview = async () => {
        const api = await window.CPB.createFrontApi('');
        const { Product } = api.State
        const customSticky = Product.metafields.find(meta => meta.key === 'custom-sticky-preview')

        if (!customSticky) return

        if (window.innerWidth <= 999) {
            const productBuilder = document.querySelector('#product-builder')
            productBuilder.classList.add('custom-sticky-preview-mobile')
        } else {
            const productBuilder = document.querySelector('#product-builder')
            productBuilder.classList.add('custom-sticky-preview')
        }

    }

    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
        addAdditionalInfo()
        fixStickyPreview()
    });
})()